import axios from './axios';

import auth from '../resources/Auth';

export default {
  getFpsConfigs: async () => {
    const url = `${process.env.REACT_APP_API_URL}/config/getFpsConfigs`;

    try {
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${auth.token}` },
      });

      return response.data;
    } catch (error) {
      console.error('Errore durante la richiesta:', error);
      throw error;
    }
  },
};
